// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseCustomerFactory instead of class inheritance

import { createBaseCustomer, type IBaseCustomer } from "../BaseCustomerFactory";
import type { IRef } from "@Front/Api/BaseApiService";
import type { CustomerRibPayload } from "./OfficeRib";

interface OfficeRibInstance {
	getRibStream(uid: string): Promise<CustomerRibPayload>;
}

// Module-level singleton instance
let instance: OfficeRibInstance | null = null;
let baseCustomerInstance: IBaseCustomer | null = null;

function createOfficeRib(): OfficeRibInstance {
	if (!baseCustomerInstance) {
		baseCustomerInstance = createBaseCustomer();
	}

	const baseCustomer = baseCustomerInstance;
	const baseUrl = baseCustomer.namespaceUrl.concat("/office");

	return {
		getRibStream: async (uid: string): Promise<CustomerRibPayload> => {
			const url = new URL(baseUrl.concat(`/${uid}/rib`));
			try {
				const ref: IRef = {};
				const blob = await baseCustomer.getRequest<Blob>(url, { ref });
				const contentDisposition = ref.response?.headers.get("Content-Disposition");
				const match = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(contentDisposition ?? "");
				let fileName = "rib.pdf";
				try {
					fileName = decodeURIComponent(match?.[1] ?? match?.[2] ?? fileName);
				} catch {
					// ignore decode issues, fallback to default name
				}
				return { blob, fileName };
			} catch (err) {
				// Optional RIB prefetch for client / invited notary / third party: callers handle absence silently (no toaster).
				return Promise.reject(err);
			}
		},
	};
}

export function getOfficeRibInstance(): OfficeRibInstance {
	if (!instance) {
		instance = createOfficeRib();
	}
	return instance;
}
